import { useEffect, useRef } from 'react';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import { CalendarUtil } from '../calendarUtil';
import CalendarEventsView from './calendar-grid-events-view.component';
import CalendarGridMonthView from './calendar-grid-month-view.component';


const CalendarGridView = ({ view, event,handleRecallEvents,isOrgEvent, eventHeight }) => {
  const eventRef = useRef(null);

  useEffect(() => {
    if (eventRef.current) {
      eventRef.current.style.height = `${eventHeight}px`;
    }
  }, [eventHeight]);
  return (
    <Scrollbar>
      <div
        ref={eventRef}
        className="fc-timegrid-event"
        style={{
          width: '100%',
        }}
      >
        {(() => {
          switch (view) {
            case CalendarUtil.CalenderType.DayMonth:
              return <CalendarGridMonthView event={event} isOrgEvent={isOrgEvent} handleRecallEvents={handleRecallEvents} sx={{ width: '100%' }} />;
            case CalendarUtil.CalenderType.ListWeek:
              return <CalendarEventsView event={event} isOrgEvent={isOrgEvent} handleRecallEvents={handleRecallEvents} sx={{ width: '100%' }} />;
            default:
              return null;
          }
        })()}
      </div>
    </Scrollbar>
  );
};

export default CalendarGridView;
